import React, { Component } from "react";

export default class Logo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={this.props.companiesDetails.CssLogo}>
        <div style={{margin:'5px'}}>
          <img src={this.props.companiesDetails.LOGO} alt="" />
          {this.props.companiesDetails.CompanyName !== "Serra Labs" &&
            process.env.REACT_APP_IS_PoweredByName === "true" && (
              <div
                className="sub-title"
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  backgroundColor: "#4F0088",
                  color: "white",
                  minWidth: "160px",
                  marginBottom: "5px",
                }}
              >
                Powered by Serra Labs
              </div>
            )}
        </div>
      </div>
    );
  }
}
